module.exports = __webpack_public_path__ + "static/media/HYM.b5f021d6.png";